// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__deM6W","buttons":"Password_buttons__2EXmV"};